import { gatewayConfig } from '../gatewayConfig'

export const CreditCardUseCase = {
    execute: ({ gatewayPayment, ...props }) => {
        const { gateway } = gatewayConfig({ gatewayPayment });
        return gateway(props)
    }
}
